









import BaseComponent from "@/core/components/BaseComponent";
import {Prop} from "vue-property-decorator";
import Component from "vue-class-component";
import moment from "moment";

@Component({
    components: {}
})
export default class DateView extends BaseComponent {

    // Bindings to parent
    @Prop() date!: Date;
    @Prop({default: 'D/M-YY HH:mm'}) textFormat!: string;
    @Prop({default: 'DD/MM-YY HH:mm:ss'}) toolTipFormat!: string;

    // Bindings to view
    public text?: string;
    public toolTip?: string;

    public mounted() {
        this.renderView();
    }

    private renderView() {
        this.text = moment(this.date).format(this.textFormat);
        this.toolTip = moment(this.date).format(this.toolTipFormat);
        this.isReady = true;
    }

}
